<template>
  <div class="text-center">
    <div class="app-inner-body-content">
      <img :src="require('@/assets/home-emoji.png')" alt="" width="85" height="85" class="mt-5" />
      <h1 class="h2 mt-0">
        {{ $t('message.testDrive.fromHomeLanding.heading', { businessName: this.$store.state.business.info.name }) }}
      </h1>
      <p class="mt-4">{{ $t('message.testDrive.fromHomeLanding.msg') }}</p>
    </div>
    <mobialis-button data-cy="continueBtn" class="mt-5" @click="nextPage">{{
      $t('message.common.continue')
    }}</mobialis-button>
  </div>
</template>
<script>
export default {
  name: 'TestDriveFromHome',
  methods: {
    nextPage() {
      this.$router.push({ name: `drive-choose-date-${this.baseRoute}` });
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  margin-bottom: 32px;
  margin-top: 94px;
}
p,
h1 {
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
}
@media (min-width: 576px) {
  p {
    max-width: 500px;
  }
  h1 {
    max-width: 600px;
  }
}
</style>
